// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Day from "../../utils/Day.bs.js";
import * as React from "react";
import * as CardModuleCss from "./Card.module.css";

var s = CardModuleCss;

function Card(Props) {
  var address = Props.address;
  var content = Props.content;
  var timestamp = Props.timestamp;
  var won = Props.won;
  return React.createElement("div", {
              className: s.card + " " + (
                won ? s.won : ""
              )
            }, React.createElement("p", {
                  className: s.address
                }, address), React.createElement("p", {
                  className: s.content
                }, "👋 " + content), React.createElement("p", {
                  className: s.timestamp
                }, Day.fromNow(timestamp)));
}

var make = Card;

export {
  s ,
  make ,
  
}
/* s Not a pure module */
